<template>
  <v-container
    fluid
    class="py-5 px-5 py-sm-15 px-sm-10 fill-height align-start"
  >
    <v-row>
      <v-col>
        <v-row>
          <v-col class="text-start">
            <span class="textLight--text font-weight-medium text-h5">
              {{ $t("reports.reports") }}
            </span>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="mt-5">
            <v-tabs
              v-model="selectedTab"
              color="primary"
              background-color="transparent"
            >
              <v-tab v-for="(item, index) in tabs" :key="index">
                <div
                  class="d-flex justify-center align-center py-4"
                  style="min-width: 130px"
                >
                  <v-icon size="30" class="px-2">{{ item.icon }}</v-icon>

                  <span>{{ item.text }}</span>
                </div>
              </v-tab>
            </v-tabs>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-tabs-items v-model="selectedTab" class="transparent">
              <v-tab-item
                v-if="havePermissionGetTrainingRegistrationReports"
                :transition="false"
              >
                <organization-reports />
              </v-tab-item>

              <v-tab-item
                v-if="havePermissionGetTrainingRegistrationRevenueReports"
                :transition="false"
              >
                <revenue-reports />
              </v-tab-item>

              <v-tab-item
                v-if="havePermissionGetTrainingRegistrationQuizReports"
                :transition="false"
              >
                <quiz-reports />
              </v-tab-item>

              <v-tab-item
                v-if="havePermissionGetAssessmentReports"
                :transition="false"
              >
                <AssessmentReports />
              </v-tab-item>

              <v-tab-item
                v-if="havePermissionGetTrainingRegistrationFeedbackReports"
                :transition="false"
              >
                <feed-back-reports />
              </v-tab-item>

              <v-tab-item
                v-if="havePermissionGetTrainingMatrixReports"
                :transition="false"
              >
                <training-matrix-reports />
              </v-tab-item>

              <v-tab-item
                v-if="havePermissionGetBatchReports"
                :transition="false"
              >
                <BatchReports />
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { hasPermission } from "@/app/user-module/helpers/authHelper";

import RevenueReports from "../components/RevenueReports.vue";
import FeedBackReports from "../components/FeedBackReports.vue";
import OrganizationReports from "../components/RegistrationReports.vue";
import QuizReports from "../components/QuizReports.vue";
import TrainingMatrixReports from "../components/TrainingMatrixReports.vue";
import BatchReports from "@/app/reports-module/components/BatchReports";
import AssessmentReports from "@/app/reports-module/components/AssessmentReports";

export default {
  components: {
    AssessmentReports,
    BatchReports,
    RevenueReports,
    OrganizationReports,
    QuizReports,
    FeedBackReports,
    TrainingMatrixReports,
  },
  data() {
    return {
      selectedTab: 0,
    };
  },
  mounted() {
    if (this.$route.params.data) {
      this.selectedTab = this.$route.params.data;
    }
  },
  computed: {
    tabs() {
      const items = [];

      if (this.havePermissionGetTrainingRegistrationReports) {
        items.push({
          icon: "mdi-account-supervisor-outline",
          text: this.$t("user.registration.registrations"),
        });
      }

      if (this.havePermissionGetTrainingRegistrationRevenueReports) {
        items.push({
          icon: "mdi-currency-usd",
          text: this.$t("reports.revenue"),
        });
      }

      if (this.havePermissionGetTrainingRegistrationQuizReports) {
        items.push({
          icon: "mdi-comment-question-outline",
          text: this.$t("course.quiz"),
        });
      }

      if (this.havePermissionGetAssessmentReports) {
        items.push({
          icon: "mdi-comment-question-outline",
          text: this.$t("quiz.assessments"),
        });
      }

      if (this.havePermissionGetTrainingRegistrationFeedbackReports) {
        items.push({
          icon: "mdi-message-alert-outline ",
          text: this.$t("course.courseDetails.feedback"),
        });
      }

      if (this.havePermissionGetTrainingMatrixReports) {
        items.push({
          icon: "mdi-newspaper-variant-multiple-outline",
          text: this.$t("reports.matrix.trainingMatrix"),
        });
      }

      if (this.havePermissionGetBatchReports) {
        items.push({
          icon: "mdi-check-circle-outline",
          text: this.$t("batch.batchCompletion"),
        });
      }

      return items;
    },
    havePermissionGetTrainingRegistrationReports() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["GET_REGISTRATION_REPORTS"],
      });
    },
    havePermissionGetTrainingRegistrationRevenueReports() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["GET_REVENUE_REPORTS"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    havePermissionGetTrainingRegistrationQuizReports() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["GET_QUIZ_REPORTS"],
      });
    },
    havePermissionGetAssessmentReports() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["GET_ASSESSMENT_REPORTS"],
      });
    },
    havePermissionGetTrainingRegistrationFeedbackReports() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["GET_FEEDBACK_REPORTS"],
      });
    },
    havePermissionGetTrainingMatrixReports() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["GET_TRAINING_MATRIX_REPORTS"],
      });
    },
    havePermissionGetBatchReports() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["GET_BATCH_REPORTS"],
      });
    },
  },
};
</script>
